import(/* webpackMode: "eager" */ "/opt/natoma/packages/frontend/src/app/home/page.tsx");
